var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',[_c('button',{staticStyle:{"border":"none","background":"none","margin-right":"5px"}},[_c('feather-icon',{staticClass:"cursor-pointer",staticStyle:{"color":"#28c76f"},attrs:{"icon":"CheckIcon","svgClasses":"w-8 h-8"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }